import ThemeToggle from "@ext/Theme/components/ThemeToggle";

const TopMenuThemeToggle = () => <ThemeToggle isHomePage />;

export default TopMenuThemeToggle;
